import ConsoleService from './../../consoleServiceModules/ConsoleService';

import ConsoleServiceIndexedDbModuleReceiptComponent from "./../../consoleServiceModules/ConsoleServiceIndexedDbModuleReceiptComponent";

import { indexed_db_name, indexed_db_version } from './../../../IndexedDbComponent';

const execute = (payload) => {

    let component_name = 'IndexedDbReceiptV2UpdateComponent';

    let flag_console_log = ConsoleServiceIndexedDbModuleReceiptComponent;

    ConsoleService('', flag_console_log);
    ConsoleService(component_name, flag_console_log);

    ConsoleService(component_name + ' / payload', flag_console_log);
    ConsoleService(payload, flag_console_log);

    let idb_name = indexed_db_name;

    ConsoleService(component_name + ' / IndexedDb / idb name', flag_console_log);
    ConsoleService(idb_name, flag_console_log);

    let version = indexed_db_version;

    ConsoleService(component_name + ' / IndexedDb / version', flag_console_log);
    ConsoleService(version, flag_console_log);

    return new Promise(
        (resolve, reject) => {

            ConsoleService(component_name + ' / new promise', flag_console_log);

            let indexedDB = window.indexedDB || window.mozIndexedDB || window.webkitIndexedDB || window.msIndexedDB || window.shimIndexedDB;

            /*
             *
             * request
             *
             * start
             * 
             */

            let request = indexedDB.open(idb_name, version);

            /*
             * request / on success / callback
             *
             * start
             * 
             */

            request.onsuccess = function (event) {

                ConsoleService(component_name + ' / request / on success', flag_console_log);

                ConsoleService(component_name + ' / request / on success / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                let db = event.target.result;

                /*
                 *
                 * transaction
                 *
                 * start
                 * 
                 */

                /*
                 *
                 * transaction
                 * 
                 * open a read/write db transaction, ready for adding the data
                 * 
                 * https://developer.mozilla.org/en-US/docs/Web/API/IDBDatabase/transaction
                 * 
                 */

                let transaction = db.transaction(['receipt_v2_object_store'], 'readwrite');

                ConsoleService(component_name + ' / request / on success / transaction', flag_console_log);
                ConsoleService(transaction, flag_console_log);

                /*
                 * report on the success of opening the transaction
                 */

                transaction.oncomplete = function (event) {

                    ConsoleService(component_name + ' / request / on success / transaction / on complete', flag_console_log);

                    ConsoleService(component_name + ' / request / on success / transaction / on complete / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    resolve(event);

                }

                transaction.onerror = function (event) {

                    ConsoleService(component_name + ' / request / on success / transaction / on error', flag_console_log);

                    ConsoleService(component_name + ' / request / on success / transaction / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * transaction
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store
                 *
                 * start
                 * 
                 */

                let objectStore = transaction.objectStore('receipt_v2_object_store');

                ConsoleService('store', flag_console_log);
                ConsoleService(objectStore, flag_console_log);

                ConsoleService(component_name + ' / objectStore.indexNames', flag_console_log);
                ConsoleService(objectStore.indexNames, flag_console_log);

                ConsoleService(component_name + ' / objectStore.keyPath', flag_console_log);
                ConsoleService(objectStore.keyPath, flag_console_log);

                ConsoleService(component_name + ' / objectStore.name', flag_console_log);
                ConsoleService(objectStore.name, flag_console_log);

                ConsoleService(component_name + ' / objectStore.transaction', flag_console_log);
                ConsoleService(objectStore.transaction, flag_console_log);

                ConsoleService(component_name + ' / objectStore.autoIncrement', flag_console_log);
                ConsoleService(objectStore.autoIncrement, flag_console_log);

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * start
                 * 
                 */

                let objectStoreRequest = objectStore.put(payload);

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onsuccess = function (event) {

                    ConsoleService(component_name + ' / request / on success / objectStoreRequest / on success', flag_console_log);

                    ConsoleService(component_name + ' / request / on success / objectStoreRequest / on success / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    //resolve(event);

                }

                /*
                 *
                 * objectStoreRequest / on success
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * start
                 * 
                 */

                objectStoreRequest.onerror = function (event) {

                    ConsoleService(component_name + ' / request / on success / objectStoreRequest / on error', flag_console_log);

                    ConsoleService(component_name + ' / request / on success / objectStoreRequest / on error / event', flag_console_log);
                    ConsoleService(event, flag_console_log);

                    reject(event);

                }

                /*
                 *
                 * objectStoreRequest / on error
                 *
                 * stop
                 * 
                 */

                /*
                 *
                 * object store request "objectStoreRequest"
                 *
                 * stop
                 * 
                 */

            }

            /*
             * request / on success / callback
             *
             * stop
             * 
             */

            /*
             * request / on error / callback
             *
             * start
             * 
             */

            request.onerror = function (event) {

                ConsoleService(component_name + ' / request / on error', flag_console_log);

                ConsoleService(component_name + ' / request / on error / event', flag_console_log);
                ConsoleService(event, flag_console_log);

                reject(event);

            }

            /*
             * request / on error / callback
             *
             * stop
             * 
             */

        }
    );

    //

}

export default execute;